export const GET_MASTER_SUCCESS = 'master/GET_MASTER_SUCCESS';
export const GET_MASTER_USERS_SUCCESS = 'master/GET_MASTER_USERS_SUCCESS';
export const ADD_MASTER_SUCCESS = 'master/ADD_MASTER_SUCCESS';
export const UPDATE_MASTER_ACCESS_SUCCESS = 'master/UPDATE_MASTER_ACCESS_SUCCESS';
export const REMOVE_MASTER_SUCCESS = 'master/REMOVE_MASTER_SUCCESS';
export const SET_MASTER_ACCESS = 'master/SET_MASTER_ACCESS';
export const CREATE_BROKERAGE_SUCCESS = 'advisors/CREATE_BROKERAGE_SUCCESS';
export const UPDATE_MASTER_STATUS = 'master/UPDATE_MASTER_STATUS';